export const Items: {[k: string]: ModdedItemData} = {
	custapberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	enigmaberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	jabocaberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	keeberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	marangaberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	micleberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	prismscale: {
		inherit: true,
		isNonstandard: "Past",
	},
	razorfang: {
		inherit: true,
		isNonstandard: "Past",
	},
	reapercloth: {
		inherit: true,
		isNonstandard: "Past",
	},
	rowapberry: {
		inherit: true,
		isNonstandard: "Unobtainable",
	},
	syrupyapple: {
		inherit: true,
		isNonstandard: "Future",
	},
};
